import { render, staticRenderFns } from "./create-game-service.vue?vue&type=template&id=e48f8bda&scoped=true&"
import script from "./create-game-service.vue?vue&type=script&lang=js&"
export * from "./create-game-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48f8bda",
  null
  
)

export default component.exports